export default __webpack_public_path__ + "static/media/faded-arrows.f8fdcb45.svg";